import { GithubOutlined } from "@ant-design/icons";
import { DefaultFooter } from "@ant-design/pro-components";
import React from "react";

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: "none",
      }}
      copyright="Powered by Yoyo Admin"
      links={[
        {
          key: "Yoyo Admin",
          title: "Yoyo Admin",
          href: "https://pro.ant.design",
          blankTarget: true,
        },
        {
          key: "github",
          title: <GithubOutlined />,
          href: "#",
          blankTarget: true,
        },
        {
          key: "Ant Design",
          title: "Ant Design",
          href: "https://ant.design",
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
